import * as React from 'react';
import { observer } from 'mobx-react';
import { Accordion, LabelSlide } from 'elc-accordion';
import { classes } from '../../utils/Classes';

export interface IProductAccordion {
    iconType?: string;
    accordionDefaultOpen: boolean;
    accordionTitle: string;
    accordionSubtext: string;
    children: JSX.Element;
    onChange?(openIndex: number): void;
}

export const ProductAccordion = observer((props: IProductAccordion) => {
    const productAccordionClassNames = classes('product-accordion');

    const { iconType, accordionDefaultOpen, accordionTitle, accordionSubtext, onChange } = props;

    const openIndex = accordionDefaultOpen ? 0 : -1;

    return (
        <Accordion className={productAccordionClassNames} openIndex={openIndex} onChange={onChange}>
            <LabelSlide id={accordionTitle} title={accordionTitle} iconType={iconType}>
                {accordionSubtext}
                {props.children}
            </LabelSlide>
        </Accordion>
    );
});
